(() => {
  const ready = (fn) => {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  };

  const whenImagesReady = (root) => {
    const imgs = Array.from(root.querySelectorAll('img'));
    const pending = imgs.filter((img) => !img.complete);
    if (pending.length === 0) return Promise.resolve();

    return new Promise((resolve) => {
      let left = pending.length;
      const done = () => {
        left -= 1;
        if (left <= 0) resolve();
      };
      pending.forEach((img) => {
        img.addEventListener('load', done, { once: true });
        img.addEventListener('error', done, { once: true });
      });
    });
  };

  const initSection = async (section) => {
    if (!section || section.__sbInited) return;
    section.__sbInited = true;

    // Solo aplica al modo animado
    if (section.classList.contains('sb--no-anim')) return;

    const track = section.querySelector('[data-sb-track]');
    const base = section.querySelector('[data-sb-content="base"]');
    const viewport = section.querySelector('.sb__viewport');

    if (!track || !base || !viewport) return;

    const rebuild = async () => {
      // Limpia clones previos
      track.querySelectorAll('[data-sb-clone="true"]').forEach((n) => n.remove());

      // Espera imágenes para ancho estable
      await whenImagesReady(section);

      // Medidas
      const baseWidth = Math.ceil(base.getBoundingClientRect().width);
      const vpWidth = Math.ceil(viewport.getBoundingClientRect().width);

      if (!baseWidth || baseWidth < 10) return;

      // Define cuánto se desplaza el track (exactamente el ancho del set base)
      track.style.setProperty('--sb-shift', `${baseWidth}px`);

      // Crea clones suficientes para que NUNCA exista un hueco
      // Necesitamos cubrir: viewport + baseWidth (porque se desplaza un baseWidth completo)
      let covered = baseWidth;
      while (covered < vpWidth + baseWidth + 50) {
        const clone = base.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.dataset.sbClone = 'true';
        track.appendChild(clone);
        covered += baseWidth;
      }
    };

    // Primera construcción
    await rebuild();

    // Rebuild en resize / cambios de layout
    const ro = new ResizeObserver(() => {
      // Pequeño debounce
      clearTimeout(section.__sbT);
      section.__sbT = setTimeout(() => rebuild(), 80);
    });
    ro.observe(viewport);
    ro.observe(base);

    // Si Shopify recarga la sección
    section.addEventListener('shopify:section:reorder', () => rebuild());
  };

  const initAll = () => {
    document.querySelectorAll('[data-sb-section]').forEach((s) => initSection(s));
  };

  ready(() => {
    initAll();

    // Shopify theme editor events
    document.addEventListener('shopify:section:load', (e) => {
      const scope = e.target;
      const sec = scope.querySelector?.('[data-sb-section]');
      if (sec) initSection(sec);
      else initAll();
    });

    document.addEventListener('shopify:section:select', (e) => {
      const scope = e.target;
      const sec = scope.querySelector?.('[data-sb-section]');
      if (sec) initSection(sec);
    });
  });
})();